import { DatatableColumnDate } from "@/domain/view/components/datatable/datatable-template-columns/datatable-column-date";
import { DatatableColumn } from "@/domain/view/components/datatable/datatable-types";

import { IndicatorListItem } from "../../../models/indicator-model";

export const COLUMN_ID_INDICATOR_UPDATED_AT = "indicator_updated_at";
export const COLUMN_ORDER_VALUE_INDICATOR_UPDATED_AT = 108;
export const COLUMN_ID_INDICATOR_UPDATED_AT_DISPLAY_VALUE = "Aktualisiert am";

interface IndicatorUpdatedAtColumnProps {
  columnId?: string;
  orderValue?: number;
  displayValue?: string;
}

export const IndicatorUpdatedAtColumn = ({
  columnId = COLUMN_ID_INDICATOR_UPDATED_AT,
  orderValue = COLUMN_ORDER_VALUE_INDICATOR_UPDATED_AT,
  displayValue = COLUMN_ID_INDICATOR_UPDATED_AT_DISPLAY_VALUE,
}: IndicatorUpdatedAtColumnProps = {}): DatatableColumn<IndicatorListItem> => {
  return DatatableColumnDate({
    columnId,
    orderValue,
    displayValue,
    getDateField: (item) => {
      return new Date(item.updatedAt);
    },
  });
};
